import { styled, keyframes } from 'styled-components';

const growAnimation = keyframes`
    from {transform: scale(0,0); opacity: 0;}
    to {transform: scale(1,1); opacity: 1;}
`;

const moveAnimation = keyframes`
    from {transform: translateX(0px)}
    to {transform: translateX(45px)}
`;

export const StyledCustomLoader = styled.div`
    height: 15px;
    width: 105px;
    display: flex;
    position: relative;

    .circle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.color.primary};
        animation: ${moveAnimation} 1000ms linear 0ms infinite;
        margin-right: 30px;

        &:first-child {
            position: absolute;
            top: 0;
            left: 0;
            animation: ${growAnimation} 1000ms linear 0ms infinite;
        }

        &:last-child {
            position: absolute;
            top: 0;
            right: 0;
            margin-right: 0;
            animation: ${growAnimation} 1000ms linear 0s infinite reverse;
        }
    }
`;

const rotate = keyframes`
    0%{
        transform:rotate(0deg);
    }

    100%{
        transform:rotate(360deg);
    }
`;

export const StyledCustomLoaderCircular = styled.span`
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 100%;
    border: 2px solid ${({ theme }) => theme.color.primary};
    border-top: 1px solid white;
    animation-name: ${rotate};
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1s;
`;
